import http from './http';

export async function listAdminAccounts() {
  const { data } = await http.get('/admin/admin-accounts');
  return data;
}
